import { BookingStop } from './booking.model';

const LOCALE = 'es-MX';
const MONEY = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: 'MXN' });

/** Lo que usa Movilidad cuando el campus no define `days_to_book`. */
export const DEFAULT_DAYS_TO_BOOK = 7;

export function formatMoney(value: number): string {
  return MONEY.format(value);
}

export interface BookingDay {
  /** "AAAA-MM-DD" en la hora del dispositivo. */
  id: string;
  weekday: string;
  day: string;
  fullLabel: string;
  /** "hoy 22 ago", "lun 24 ago": el título de la lista de salidas. */
  shortLabel: string;
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** Los días de la tira, desde hoy. Con un valor inválido o sin definir, `DEFAULT_DAYS_TO_BOOK`. */
export function bookingDays(daysToBook: number | null | undefined, now = new Date()): BookingDay[] {
  const count = Number.isInteger(daysToBook) && (daysToBook as number) > 0 ? (daysToBook as number) : DEFAULT_DAYS_TO_BOOK;

  return Array.from({ length: count }, (_, offset) => {
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekday = new Intl.DateTimeFormat(LOCALE, { weekday: 'short' }).format(date).replace('.', '');
    const monthName = new Intl.DateTimeFormat(LOCALE, { month: 'short' }).format(date).replace('.', '');
    const long = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' }).format(date).replace(',', '');
    return {
      id: `${date.getFullYear()}-${month}-${day}`,
      weekday: offset === 0 ? 'Hoy' : capitalize(weekday),
      day: String(date.getDate()),
      fullLabel: offset === 0 ? `Hoy, ${long}` : capitalize(long),
      shortLabel: `${offset === 0 ? 'hoy' : weekday} ${date.getDate()} ${monthName}`,
    };
  });
}

/** "13:00:00" → "13:00". */
export function departureTime(startsAt: string): string {
  return startsAt.slice(0, 5);
}

function normalize(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

/** Sin distinguir acentos ni mayúsculas: "gonzalitos" encuentra "Gonzalitos", "tecnologico" a "Tecnológico". */
export function matchesStop(stop: Pick<BookingStop, 'name'> & { routeName?: string }, query: string): boolean {
  const wanted = normalize(query.trim());
  return !wanted || normalize(`${stop.name} ${stop.routeName ?? ''}`).includes(wanted);
}
